import { render, staticRenderFns } from "./IdentRouting.vue?vue&type=template&id=5324ae2a&scoped=true"
import script from "./IdentRouting.vue?vue&type=script&lang=js"
export * from "./IdentRouting.vue?vue&type=script&lang=js"
import style0 from "./IdentRouting.vue?vue&type=style&index=0&id=5324ae2a&prod&scoped=true&lang=css"
import style1 from "highlight.js/styles/github.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5324ae2a",
  null
  
)

export default component.exports